/*
 *
 * StructurePhoneInput
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 03-Mar-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import './StructurePhoneInput.scss'
import PortalPhoneInput from '@nexidigital/portalphoneinput'
import { handleOnlyNumberKeyDown } from 'Utility/numberMethods'
import prefixOptions from 'Schemas/countries.json'
import { messages } from './languageModule'

const StructurePhoneInput = ({ formik }) => {
  const intl = useIntl()
  return (
    <PortalPhoneInput
      id='mobilePhone'
      phoneLabel={intl.formatMessage(messages.phoneNumber)}
      pathToDirectFlags={process.env.COUNTRY_FLAGS_URL}
      imageType='svg'
      maxLength={15}
      onPrefixChangeHandler={({ value }) => formik.setFieldValue('phoneCountryCode', value)}
      onPrefixBlurHandler={() => formik.setFieldTouched('phoneCountryCode', true)}
      error={formik.errors.phone && formik.touched.phone}
      errorText={formik.errors.phone}
      selectedPrefix={formik.values.phoneCountryCode}
      phonePrefixes={prefixOptions}
      prefixLabel={intl.formatMessage(messages.countryCode)}
      formik={formik.getFieldProps('phone')}
      prefixPlaceholder={intl.formatMessage(messages.select)}
      placeholder={intl.formatMessage(messages.enterNumber)}
      prefixError={formik.errors.phoneCountryCode && formik.touched.phoneCountryCode}
      prefixErrorText={formik.errors.phoneCountryCode}
      onKeyDown={handleOnlyNumberKeyDown}
    />
  )
}

StructurePhoneInput.propTypes = {
  formik: PropTypes.object.isRequired
}

StructurePhoneInput.defaultProps = {
  // Add here some default propTypes values
}

export default StructurePhoneInput
